import React, { useCallback, useState } from 'react'
import { DockablePanel } from 'src/components/Reusable/DockablePanel/DockablePanel'
import { useAnalytics } from '../analytics/useAnalytics'
import { useInfoPanelContext } from './InfoPanelContext'
import { DEFAULT_LOOKBACK_DAYS } from './Changelog/useChangeLogEntries'

export const InfoPanel = (): JSX.Element => {
  const [attached, setAttached] = useState(false)
  const { track, events } = useAnalytics()
  const { infoPanelState, setInfoPanelState } = useInfoPanelContext()
  const { isShown, render, title } = infoPanelState
  const content = isShown ? render : <></>

  const close = useCallback(() => {
    track(events.V_ACTIVITY_LOG, { toggle: 'close', source: 'panel' })
    setInfoPanelState({
      isShown: false,
      render: <div></div>,
    })
  }, [track, setInfoPanelState, events])

  return (
    <DockablePanel
      title={title || 'Activities'}
      titleAdornment={`(showing last ${DEFAULT_LOOKBACK_DAYS} days)`}
      show={isShown}
      width={360}
      onClose={close}
      attached={attached}
      onAttach={() => setAttached(true)}
      onDetach={() => setAttached(false)}
    >
      {content}
    </DockablePanel>
  )
}
